export default __webpack_public_path__ + "static/media/sanmar7.228cde27.jpg";